<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "AboutUsDesktop"
}
</script>

<style scoped>

</style>